export const CONTRACT_STATUSES = [
  'DRAFT', 'SUBMITTED',  'AWARDED', 'ACCEPTED',
  'REJECTED', 'CANCELLED', 'WORK_ORDER_ISSUED', 'MOBILIZED', 'WORK_IN_PROGRESS',
  'ON_HOLD', 'RESUMED', 'COMPLETED', 'SUBMITTED_FOR_APPROVAL', 'APPROVED',
  'PAYMENT_PENDING', 'PAYMENT_RECEIVED', 'CLOSED', 'TERMINATED', 'DISPUTE'
];

export const SECURITY_DEPOSIT_STATUSES = [
  'DRAFT', 'SUBMITTED',   
  'REJECTED', 'CANCELLED',  
  'REFUNDED' , 'FORFEITED', 'RELEASED', 'PENDING_RELEASE', 'PENDING_REFUND'
];